import R from 'ramda';
import React, { Component } from 'react';
import { Row, Col, FormGroup, Radio } from 'react-bootstrap';
import FontAwesome from 'react-fontawesome';
import getContent from '../ContractBlock/Contents/CureRemedies';
import Select from '../Select';
import ChangeRequestsView from '../Deals/DealEditPages/ChangeRequestsView';

export default class CureRemedies extends Component {
  constructor(props) {
    super(props);
    this.state = { adjust: undefined, adjust2: undefined, changes: {} };
  }

  options = () => ({
    field1: this.state.changes.field1,
    field2: this.state.changes.field2,
    field3: this.state.changes.field3,
  });

  oldOptions = () => ({
    field1: this.props.field1,
    field2: this.props.field2,
    field3: this.props.field3,
  });

  getOptions() {
    const oldOptions = this.oldOptions();
    const options = this.options();

    if (this.state.adjust) {
      oldOptions.field1 = options.field1;
      oldOptions.field3 = options.field3;
    } else if (this.state.adjust === undefined) {
      oldOptions.field1 = undefined;
      oldOptions.field3 = undefined;
    }

    if (this.state.adjust2) {
      oldOptions.field2 = options.field2;
    } else if (this.state.adjust === undefined) {
      oldOptions.field2 = undefined;
    }

    return oldOptions;
  }

  componentDidMount() {
    if (this.props.dealBlocks) {
      this.getBlockChanges(this.props.dealBlocks);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.dealBlocks) {
      this.getBlockChanges(nextProps.dealBlocks);
    }
  }

  getBlockChanges(dealBlocks) {
    const block = R.find(R.propEq('id', this.props.block.id))(dealBlocks);
    if (block) {
      const state = {
        changes: block.changes || {},
        // adjust: block.accept === undefined ? undefined : (block.accept ? !block.accept : (block.changes ? true : undefined))
        adjust: block.accept === undefined ? undefined : !block.accept,
      };

      if (this.props.agreement && this.props.agreement.type === 'premium') {
        // state.adjust2 = block.accept2 === undefined ? undefined : (block.accept2 ? !block.accept2 : (block.changes ? true : undefined))
        state.adjust2 =
          block.accept2 === undefined ? undefined : !block.accept2;
      }
      this.setState(state);
    }
  }

  handleAdjust(adjust, value) {
    const states = this.state;

    states[adjust] = value;
    this.setState(states);

    if (states.adjust === false && states.adjust2 === false) {
      this.props.removeBlockChanges(this.props.block.id);
    } else {
      const { block, agreement } = this.props;
      const options = this.getOptions();

      this.props.setBlockChanges({
        id: block.id,
        options,
        ...getContent(options, agreement.type),
        accept: states.adjust === undefined ? undefined : !states.adjust,
        accept2: states.adjust2 === undefined ? undefined : !states.adjust2,
      });
    }
  }

  handleContent(field, index) {
    const { block, agreement } = this.props;
    const options = this.getOptions();
    options[field] = index;

    // if (field === 'field1' && index === 1) {
    //     options['field3'] = undefined;
    // }

    this.props.setBlockChanges({
      id: block.id,
      options,
      ...getContent(options, agreement.type),
      accept: this.state.adjust === undefined ? undefined : !this.state.adjust,
      accept2:
        this.state.adjust2 === undefined ? undefined : !this.state.adjust2,
    });
  }

  renderOriginal() {
    if (this.props.field1 === 0) {
      return `Yes, there should be a window of ${this.props.field3} days when a breaching party can fix (cure) the breach.`;
    } else if (this.props.field1 === 1) {
      return `No, a notice and cure period is not required before rights under this agreement can be enforced.`;
    }

    return null;
  }

  renderAdjust() {
    const { adjust, changes } = this.state;

    if (adjust === true) {
      return (
        <div className="inner-content">
          <FormGroup className="answer">
            <Radio
              name="cure-field1"
              checked={changes.field1 === 0}
              readOnly
              onClick={(e) => this.handleContent('field1', 0)}
            >
              Yes, there should be a window of
              <Select
                className="select-mini"
                value={changes.field3}
                onChange={(e) => this.handleContent('field3', e.target.value)}
              >
                <option value="">Select Date</option>
                <option value="10">10</option>
                <option value="15">15</option>
                <option value="30">30</option>
              </Select>
              days when a breaching party can fix (cure) the breach.
            </Radio>
            <Radio
              name="cure-field1"
              checked={changes.field1 === 1}
              readOnly
              onClick={(e) => this.handleContent('field1', 1)}
            >
              No, a notice and cure period is not required before rights under
              this agreement can be enforced.
            </Radio>
          </FormGroup>
        </div>
      );
    } else {
      return null;
    }
  }

  renderOriginal2() {
    if (this.props.field2 === 0) {
      return `No. Only monetary damages can be pursued.`;
    } else if (this.props.field2 === 1) {
      return `Yes. The parties should be able to seek injunctive relief, in addition to other remedies available to them like monetary damages.`;
    }

    return null;
  }

  renderAdjust2() {
    const { adjust2, changes } = this.state;

    if (adjust2 === true) {
      return (
        <div className="inner-content">
          <FormGroup className="answer">
            <Radio
              name="cure-field2"
              checked={changes.field2 === 0}
              readOnly
              onClick={(e) => this.handleContent('field2', 0)}
            >
              No. Only monetary damages can be pursued.
            </Radio>
            <Radio
              name="cure-field2"
              checked={changes.field2 === 1}
              readOnly
              onClick={(e) => this.handleContent('field2', 1)}
            >
              Yes. The parties should be able to seek injunctive relief, in
              addition to other remedies available to them like monetary
              damages.
            </Radio>
          </FormGroup>
        </div>
      );
    } else {
      return null;
    }
  }

  renderChangeRequest(changeRequest) {
    if (changeRequest.changes.field1 === 0) {
      return `Yes, there should be a window of ${changeRequest.changes.field3} days when a breaching party can fix (cure) the breach.`;
    } else if (changeRequest.changes.field1 === 1) {
      return `No, a notice and cure period is not required before rights under this agreement can be enforced.`;
    }

    return `None`;
  }

  renderChangeRequest2(changeRequest) {
    if (changeRequest.changes.field2 === 0) {
      return `No. Only monetary damages can be pursued.`;
    } else if (changeRequest.changes.field2 === 1) {
      return `Yes. The parties should be able to seek injunctive relief, in addition to other remedies available to them like monetary damages.`;
    }

    return `None`;
  }

  renderChangeRequests(type) {
    let changeRequests = [];
    if (type === 'premium') {
      changeRequests = this.props.changeRequests2;
    } else {
      changeRequests = this.props.changeRequests;
    }

    return (
      <ChangeRequestsView
        changeRequests={changeRequests}
        renderChangeRequest={(changeRequest) =>
          type === 'premium'
            ? this.renderChangeRequest2(changeRequest)
            : this.renderChangeRequest(changeRequest)
        }
      />
    );
  }

  render() {
    return (
      <div className="tab-content">
        <Row>
          {!this.props.finalized && !this.props.isAttorney && (
            <Col sm={12}>
              <p className="question">
                If a party breaches this agreement, should they have a chance to
                fix the breach before they can be sued?
              </p>
              <FormGroup className="answer">
                <Radio
                  name="cure-adjust"
                  checked={this.state.adjust === false}
                  readOnly
                  onClick={(e) => this.handleAdjust('adjust', false)}
                >
                  {this.props.userInfo.same
                    ? `Keep my original proposal: `
                    : `Accept ${this.props.userInfo.name} 's proposed terms: `}
                  <div className="pt-7px">{this.renderOriginal()}</div>
                </Radio>
                <hr />
                <Radio
                  name="cure-adjust"
                  checked={this.state.adjust === true}
                  readOnly
                  onClick={(e) => this.handleAdjust('adjust', true)}
                >
                  {this.props.userInfo.same
                    ? `Change my proposal:`
                    : `Suggest an alternative:`}
                </Radio>
              </FormGroup>
              {this.renderAdjust()}
              {this.props.renderAccepts()}
              {this.renderChangeRequests()}
              <br />

              {this.props.agreement.type === 'premium' ? (
                <div className="pt5">
                  <p className="question">
                    Should parties be able to seek other forms of remedies
                    besides monetary damages, such as injunctions, specific
                    actions, rescission, restitution etc. (“equitable relief)?
                  </p>
                  <FormGroup className="answer">
                    <Radio
                      name="cure-adjust2"
                      checked={this.state.adjust2 === false}
                      readOnly
                      onClick={(e) => this.handleAdjust('adjust2', false)}
                    >
                      {this.props.userInfo.same
                        ? `Keep my original proposal: `
                        : `Accept ${this.props.userInfo.name} 's proposed terms: `}
                      <div className="answer pt2">{this.renderOriginal2()}</div>
                    </Radio>
                    <hr />
                    <Radio
                      name="cure-adjust2"
                      checked={this.state.adjust2 === true}
                      readOnly
                      onClick={(e) => this.handleAdjust('adjust2', true)}
                    >
                      {this.props.userInfo.same
                        ? `Change my proposal:`
                        : `Suggest an alternative:`}
                    </Radio>
                  </FormGroup>
                  {this.renderAdjust2()}
                  {this.props.renderAccepts2()}
                  {this.renderChangeRequests('premium')}
                </div>
              ) : null}
            </Col>
          )}
          {!this.props.finalized && !this.props.isAttorney && (
            <Col sm={12}>{this.props.children}</Col>
          )}

          <Col sm={12}>
            <div className="notes">
              <h4>
                <FontAwesome name="question-circle" />
                Need Some Help?
              </h4>
              <div className="expand" tabIndex="0">
                <p className="question">Why is this important?</p>
                <p className="small">
                  Things can go wrong. When this happens, this clause provides
                  guidelines for how long a collaborator at fault has to fix the
                  problem. If the problem is not fixed, this clause provides
                  guidelines for the actions/recourse that collaborators who are
                  not at fault can take.
                </p>
              </div>
              <div className="expand" tabIndex="0">
                <p className="question">What is a "breach"?</p>
                <p className="small">
                  A breach is the failure of a collaborator to perform/practice
                  the obligations that were agreed to.
                </p>
              </div>
              <div className="expand" tabIndex="0">
                <p className="question">What is a "cure"?</p>
                <p className="small">
                  A cure is a remedy to a breach. It is the opportunity for the
                  collaborator who has breached the agreement to fix the
                  problem.
                </p>
              </div>
              <div className="expand" tabIndex="0">
                <p className="question">What is a "remedy"?</p>
                <p className="small">
                  A "remedy" is an outcome such as a penalty or enforcement that
                  is ordered by a court in order to fix a problem. For example,
                  “damages” are a remedy.
                </p>
              </div>
              <div className="expand" tabIndex="0">
                <p className="question">What are "damages"?</p>
                <p className="small">
                  "Damages" are a legal remedy to a breach. Typically, that
                  remedy is money that is paid to a person as compensation for
                  loss or injury.
                </p>
              </div>
              <div className="expand" tabIndex="0">
                <p className="question">What is "equitable relief"?</p>
                <p className="small">
                  "Equitable" relief can include injunctions (which prohibits a
                  specific action, like the distribution of a work), specific
                  performance (requiring that a certain action be taken),
                  rescission (the revocation of an agreement), and restitution
                  (restoration of property and/or a financial award).
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// src/components/DealContractBlock/CureRemedies.jsx